<input
  (keydown.tab)="onTab($event)"
  (selectItem)="onSelected($event)"
  [(ngModel)]="amtModel"
  [autofocus]="hasfocus"
  [inputFormatter]="inputFormatter"
  [ngbTypeahead]="search"
  [placeholder]="placeholder ?? ''"
  [resultFormatter]="resultFormatter"
  #searchInput
  class="form-control typeahead-input"
  type="search" />
